import AgreementContent from "./agreement-content";

export default AgreementContent;
